module.exports = __webpack_public_path__ + "img/contacto-icono-whatsapp.527b063c.svg";